// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/group-list/group-list.less
// module id = 3633
// module chunks = 0